import { InvitationStatusEnum } from '@seaters/constants';

export const statusesToCancel = [
  InvitationStatusEnum.BEING_REVIEWED,
  InvitationStatusEnum.DEMAND_ACCEPTED,
];

export const statusesToAccept = [InvitationStatusEnum.RSVP_TO_ACCEPT];
export const statusesToTickets = [InvitationStatusEnum.RSVP_CONFIRMED];

// Statuses where compose email action is available
// Also includes RSVP_CONFIRMED so host can view what was sent
export const statusesToComposeEmail = [
  InvitationStatusEnum.BEING_REVIEWED,
  InvitationStatusEnum.DEMAND_ACCEPTED,
  InvitationStatusEnum.RSVP_TO_ACCEPT,
  InvitationStatusEnum.RSVP_CONFIRMED,
];
